import { NavLink } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./styles.css";
import {
  FaChartBar,
  FaUsers,
  FaShieldAlt,
  FaWallet,
  FaExchangeAlt,
  FaLock,
  FaCog,
} from "react-icons/fa";
import AuthService from "../session/AuthService";

const fullMenu = [
  {
    label: "Dashboard",
    icon: <FaChartBar />,
    path: "/admin/dashboard",
    userAccess: ["1"],
  },
  {
    label: "User Management",
    icon: <FaUsers />,
    path: "/admin/user-management",
    userAccess: ["1", "4", "5"],
  },

  {
    label: "Recieve Payment",
    icon: <FaUsers />,
    path: "/admin/receivePayment",
    userAccess: ["3"],
  },
  {
    label: "KYC Management",
    icon: <FaShieldAlt />,
    path: "/admin/kyc-management",
    userAccess: ["1", "4", "5"],
  },
  {
    label: "Wallet Operations",
    icon: <FaWallet />,
    path: "/admin/wallet-operations",
    userAccess: ["1", "4", "5"],
  },
  {
    label: "Transactions",
    icon: <FaExchangeAlt />,
    path: "/admin/transactions",
    userAccess: ["1", "3"],
  },
  {
    label: "Bulk Transactions",
    icon: <FaExchangeAlt />,
    path: "/admin/bulkTransactions",
    userAccess: ["2"],
  },
  {
    label: "Security",
    icon: <FaLock />,
    path: "/admin/security",
    userAccess: ["1"],
  },
  {
    label: "Settings",
    icon: <FaCog />,
    path: "/admin/settings",
    userAccess: ["1"],
  },
];

export default function Sidebar({ collapsed, onToggle }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const uType = String(AuthService.getUserData()?.uType || ""); // force string

    const filteredMenu = fullMenu.filter((item) =>
      item.userAccess.includes(uType)
    );

    setMenu(filteredMenu);
  }, []);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  return (
    <>
      {isMobile && drawerOpen && (
        <div className="sidebar-overlay" onClick={() => setDrawerOpen(false)} />
      )}

      <aside
        className={`sidebar
           ${collapsed && !isMobile ? "collapsed" : ""}
           ${isMobile && drawerOpen ? "mobile-open" : ""}`}
      >
        <div className="sidebar-logo">
          {collapsed && !isMobile ? "WA" : "WalletAdmin"}
        </div>

        <nav>
          <ul>
            {menu.map((item) => (
              <li key={item.label}>
                <NavLink
                  to={item.path}
                  onClick={() => isMobile && setDrawerOpen(false)}
                >
                  <span className="sidebar-icon">{item.icon}</span>
                  {(!collapsed || isMobile) && (
                    <span className="sidebar-label">{item.label}</span>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>

      {isMobile && !drawerOpen && (
        <button className="sidebar-mobile-btn" onClick={toggleDrawer}>
          ☰
        </button>
      )}
    </>
  );
}
